import { TokenData } from 'modules/application-link/domain/interfaces/token-data';
import { restApi } from 'shared/api/rest-api';

/**
 * Публичная страница онлайн-заявки: расшифровка токена из ссылки (`GET application/decode-token`).
 *
 * Повторов нет — у `restBaseQuery` их и не бывает: просроченная или битая ссылка от повтора не починится.
 * Перезапрос по фокусу страница выключает в хуке (`refetchOnFocus: false`): на телефоне возврат из системного
 * выбора фото возвращает вкладке фокус, и перезапрос снёс бы форму вместе со всем, что человек ввёл.
 */
export const applicationsApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    decodeApplicationToken: build.query<TokenData, string>({
      query: (token) => ({ url: 'application/decode-token', params: { token } }),
    }),
  }),
  overrideExisting: false,
});

export const { useDecodeApplicationTokenQuery } = applicationsApi;
